import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import MailSettings from "./MailSettings";
import ValidityTime from "./ValidityTime";
import DocumentTime from "./DocumentTime";
import Divider from "@mui/material/Divider";
import DocumentationFormUpload from "./DocumentationForm";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>Allgemeine Einstellungen</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            sx={{ mt: 0, ml: 1, mb: 1 }}
            color="text.secondary"
            display="block"
            variant="6"
          >
            Gültigkeitsdauer von bestandenen Prüfungen
          </Typography>
          <ValidityTime />
          <Divider sx={{ mt: 2, mb: 2 }} />
          <Typography
            sx={{ mt: 0.5, ml: 1, mb: 1 }}
            color="text.secondary"
            display="block"
            variant="6"
          >
            PDF Lebensdauer von bestandenen Prüfungsergebnissen
          </Typography>
          <DocumentTime />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>E-Mail Einstellungen</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MailSettings />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Dokumentationsbogen</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DocumentationFormUpload />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
